import React from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { 
  Button, 
  Modal, 
} from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'

const ActionCommentModal = props => {
  const { 
    actionName,
    setShowDialogComment,
    submit
  } = props
  
  return (
    <Modal size='tiny' open={true}>
      <Modal.Header>Are you sure?</Modal.Header>
      <Modal.Content>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {actionName==='resubmit'?
              null
            :
            <span>
              Are you sure to <b>{actionName==='delete'?'delete':actionName==='Revise'?'revise':'cancel'}</b> this document?
            </span>
          }
          {actionName!='Delete'&&<div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
            <Field 
              label='Comment'
              name='actionComment' 
              type={type.textArea}
              component={FieldInput}
              require={(actionName=='resubmit'||actionName=='delete')?false:true} />
          </div>}
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button 
          color='red' 
          type='button' 
          content={'No'}
          onClick={() => {
            setShowDialogComment(false)
          }}
        />
        <Button
          positive
          type='button'
          icon='checkmark'
          labelPosition='right'
          content={'Yes'}
          onClick={() => {
            submit()
          }}
        />
      </Modal.Actions>
    </Modal>
  )
}

const mapStateToProps = (state, props) => {
  return {
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ActionCommentModal)
